import React from 'react';
import { Route, Switch } from 'react-router';
import {
  ApiEditPage,
  ApplicationEditPage,
  ApplicationDetailsPage,
  ApiProxyEditPage,
  GatewayBundleListPage,
  OrganizationListPage,
  OrganizationEditPage,
  GatewayBundleDetailsPage,
  GatewayBundleEditPage,
  ProxyDetailsPage,
  UserListPage,
  PageNotFoundPage,
} from '../pages';
import Dashboard from '../pages/Dashboard';

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/admin/" component={Dashboard} />
      <Route exact path="/admin/app/dashboard/" component={Dashboard} />
      <Route exact path="/admin/app/guest/dashboard/" component={Dashboard} />
      <Route exact path="/admin/console/users" component={UserListPage} />
      <Route exact path="/admin/console/organizations" component={OrganizationListPage} />
      <Route exact path="/admin/console/organizations/add" component={OrganizationEditPage} />
      <Route exact path="/admin/console/organizations/edit/:orgUuid" component={OrganizationEditPage} />
      <Route exact path="/publish/apis/add/" component={ApiEditPage} />
      <Route exact path="/publish/apis/edit/:apiUuid/" component={ApiEditPage} />
      <Route exact path="/publish/apis/edit/:apiUuid/:tabName" component={ApiEditPage} />
      <Route exact path="/publish/apis/permissions/:apiUuid" component={ApiEditPage} />
      <Route exact path="/publish/apis/permissions/:apiUuid/:tabName" component={ApiEditPage} />
      <Route exact path="/publish/applications/add/" component={ApplicationEditPage} />
      <Route exact path="/publish/applications/edit/:applicationUuid/" component={ApplicationEditPage} />
      <Route exact path="/publish/applications/details/:applicationUuid/" component={ApplicationDetailsPage} />
      <Route exact path="/dev/applications/details/:applicationUuid/" component={ApplicationDetailsPage} />
      <Route exact path="/publish/applications/edit/:applicationUuid/:tabName" component={ApplicationEditPage} />
      <Route exact path="/publish/api-proxy/add/" component={ApiProxyEditPage} />
      <Route exact path="/publish/api-proxy/edit/:apiProxyUuid/" component={ApiProxyEditPage} />
      <Route exact path="/publish/gateway-bundles" component={GatewayBundleListPage} />
      <Route exact path="/publish/gateway-bundles/add" component={GatewayBundleEditPage} />
      <Route exact path="/publish/gateway-bundles/details/:bundleUuid" component={GatewayBundleDetailsPage} />
      <Route exact path="/publish/gateway-bundles/details/:bundleUuid/:tabName" component={GatewayBundleDetailsPage} />
      <Route exact path="/publish/api-proxy/details/:apiProxyUuid/" component={ProxyDetailsPage} />
      <Route exact path="/publish/api-proxy/details/:apiProxyUuid/:tabName" component={ProxyDetailsPage} />
      <Route exact path="/404" component={PageNotFoundPage} />
      <Route path="*" component={PageNotFoundPage} />
    </Switch>
  );
}



// WEBPACK FOOTER //
// ./src/routes/index.js